<template>
  <div>
    <el-dialog
      :title="form.id ? '编辑标签组' : '新建标签组'"
      :visible.sync="dialogVisible"
      width="400"
      :before-close="dialogBeforeClose"
    >
      <div>
        <el-form
          ref="form"
          :model="form"
          label-width="150px"
          label-position="left"
        >
          <el-form-item
            prop="title"
            label="标签组名称(必填)"
          >
            <el-input
              v-model="form.title"
              maxlength="15"
              show-word-limit
              style="width: 300px"
            />
          </el-form-item>
          <el-form-item
            label="标签(必填)"
            prop="children_array"
          >
            <template>
              <div
                v-for="(item, index) in form.children_array"
                :key="index"
                class="label-list"
              >
                <el-input
                  v-model="item.title"
                  class="label-input"
                  maxlength="10"
                  show-word-limit
                  :disabled="item.is_wechat === 1"
                />
                <div
                  v-if="form.children_array.length > 1 && item.is_wechat !== 1"
                  class="btn-box"
                  @click.prevent="removeLabel(item)"
                >
                  <i class="el-icon-minus btn" />
                </div>
              </div>
            </template>
          </el-form-item>

          <el-button
            type="text"
            @click="addLabel"
          >
            <div class="add-label">
              <span>添加标签</span>
              <div class="btn-box">
                <i class="el-icon-plus" />
              </div>
            </div>
          </el-button>
        </el-form>
      </div>
      <div slot="footer">
        <el-button @click="dialogBeforeClose">
          取 消
        </el-button>
        <el-button
          type="primary"
          @click="submitLabel"
        >
          确 定
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: 'SpEditLabel',
  model: {
    prop: 'dialogVisible',
    event: 'changeEditLabelVisible'
  },
  props: {
    dialogVisible: {
      type: Boolean,
      default: false
    },
    labelId: {
      type: Number,
      default: 0
    }
  },
  data () {
    return {
      form: {
        title: '',
        children_array: [
          {
            title: '',
            tags_id: 0
          }
        ]
      },
      children_delete: []
    }
  },
  watch: {
    dialogVisible (val) {
      this.children_delete = []
      if (val && !this.labelId) {
        this.form = {
          title: '',
          children_array: [
            {
              title: '',
              tags_id: 0
            }
          ]
        }
      } else if (val && this.labelId) {
        this.form.id = this.labelId
        this.initInfo(this.labelId)
      }
    }
  },
  mounted () {},
  methods: {
    async initInfo (id) {
      const data = await this.$api.customer.getTagsInfo(id)
      if (data) {
        data.children.forEach((v) => {
          v.tags_id = v.id
        })
        this.form.title = data.title
        this.form.children_array = data.children
      }
    },
    dialogBeforeClose () {
      this.$emit('changeEditLabelVisible', false)
    },
    removeLabel (item) {
      let index = this.form.children_array.indexOf(item)
      if (index !== -1) {
        if (item.id) {
          this.children_delete.push(item.id)
        }
        this.form.children_array.splice(index, 1)
      }
    },
    addLabel () {
      this.form.children_array.push({
        title: '',
        tags_id: 0
      })
    },
    async submitLabel () {
      if (!this.form.title) {
        return this.$message.error('请输入标签组名称')
      }
      if (
        this.form.children_array.length <= 0 ||
        this.form.children_array.findIndex((v) => v.title === '') !== -1
      ) {
        return this.$message.error('请输入标签名称')
      }
      if (this.form.id) {
        let children_array = []
        this.form.children_array.forEach((v) => {
          children_array.push({
            title: v.title,
            tags_id: v.tags_id
          })
        })
        const data = await this.$api.customer.updateTags(this.form.id, {
          title: this.form.title,
          children_array,
          children_delete: this.children_delete
        })
        if (data && data.status) {
          this.$message.success('编辑成功')
          this.$emit('submitLabel')
        } else {
          this.$message.error('编辑失败')
        }
      } else {
        const data = await this.$api.customer.createTags({
          title: this.form.title,
          children_title: this.form.children_array.map((v) => v.title)
        })
        if (data && data.status) {
          this.$message.success('创建成功')
          this.$emit('submitLabel')
        } else {
          this.$message.error('创建失败')
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.label-list {
  display: flex;
  align-items: center;
}
.label-input {
  width: 300px;
}
.btn-box {
  width: 20px;
  height: 20px;
  border: 1px solid #ccc;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  margin-left: 10px;
}
.add-label {
  display: flex;
  align-items: center;
  .btn-box {
    border-color: #409eff;
  }
}
</style>
